export * from './file.service';
import { FileService } from './file.service';
export * from './token.service';
import { TokenService } from './token.service';
export const APIS = [FileService, TokenService];
